import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createTliEvents = (captureTrackingEvent: CaptureTrackingEvent) => {
  const trackTliDrawerOpen = (
    source: PosthogTrackingSource,
    type: string,
    entities?: string[]
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.TLI_DRAWER_OPEN,
      properties: {
        source,
        type,
        ...(entities !== undefined && { entities }),
      },
    });

  return { trackTliDrawerOpen };
};
